export type ChatType = 'event' | 'group' | 'smatcher';
export type ChatStatus = 'active' | 'muted' | 'bloqued'  | "ended";

export const CreateChannel = 'createChannel';
export const JoinChannel = 'joinChannel';
export const ChannelJoined = 'ChannelJoined';
export const ChannelCreated = 'channelCreated';
export const SendMessage = 'send-message';
export const LeaveChannel = 'leave-channel';
export const MessageSent = 'message-sent';

export const MessageSentTo = (chatId: string) => `${MessageSent}-${chatId}`;

export type ChatMessageDataImage = { url: string };
export type ChatMessageDataDocument = { link: string, size?: number };
export type ChatMessageDataText = { text: string };

// export type ChatMessageData = ChatMessageDataText | ChatMessageDataImage | ChatMessageDataDocument;
export type ChatMessageData = ChatMessageDataText;
export type ChatMessageType = 'text' | 'image' | 'document' | 'voice' | 'video';


export interface CreateNewMessage {
  chatId: string;
  type: ChatType;
  messageType: ChatMessageType;
  messageData: ChatMessageData;
}


export interface NewMessageSent {
  _id: string;
  messageType: ChatMessageType;
  time: string;
  chatId: string;
  sentBy: string;
  messageData: ChatMessageData;
  displayName: string;
  avatarUrl?: string;
  readByUserIds: string[];
}
